module.exports = __webpack_public_path__ + "static/img/5.08fc294.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/9/sp/5.png
// module id = ALaS
// module chunks = 0